export class CsvSubscription {
  public projectId: number;
  public dataType: string[];
  public ftpServer: string;
  public ftpPort: number;
  public ftpUser: string;
  public ftpPassword: string;
  public deleteDataAfterExport: boolean;
}
